import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Header from '@components/common/Header/Header';
import CopyLinkIconBtn from '@components/common/Header/components/BtnHeaderCopyLink/BtnHeaderCopyLink';
import StatusTypeItem from '@components/common/StatusTypeItem/StatusTypeItem';

import { calcSensorHex } from '@helpers/helper';

import useTranslation from '@hooks/useTranslation';

import { useListByInstPointQuery } from '@services/useListByInstPointQuery';

import SensorCharts from './components/SensorCharts/SensorCharts';
import SensorExtraInfo from './components/SensorExtraInfo/SensorExtraInfo';
import SensorHistory from './components/SensorHistory/SensorHistory';
import SensorInformation from './components/SensorInformation/SensorInformation';
import SensorNavigation from './components/SensorNavigation/SensorNavigation';
import style from './style.module.scss';

const SensorDetails = () => {
  const { t } = useTranslation();

  const { trackPageView } = useMatomo();
  const { pointId } = useParams();

  const { data: pointData, isFetching: isPointFetching } = useListByInstPointQuery({ pointId: +pointId! });

  const actionItem = pointData?.activeRegularAi || pointData?.activeWwAi;
  const locationInfo = pointData?.equipment?.location;
  const currentHEX =
    calcSensorHex(pointData?.sensor?.sensor_id || pointData?.sensorId, pointData?.sensor?.hardware_id) || '';

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <div className={style.pageSensorDetails}>
      <Header
        title={`${t('Sensor information')}: ${currentHEX}`}
        isSecondaryPage={true}
        headerLeftComponent={actionItem && <StatusTypeItem item={actionItem} onlyTitle={true} />}
        headerRightComponent={
          <>
            <SensorNavigation />
            <CopyLinkIconBtn />
          </>
        }
        extraInfo={
          <SensorExtraInfo facilityName={locationInfo?.facilityName} locationName={locationInfo?.name} />
        }
      />
      <div className={style.pageSensorDetailsBody}>
        <SensorInformation point={pointData} sensorHEX={currentHEX} isLoading={isPointFetching} />
        <SensorHistory point={pointData} isPointLoading={isPointFetching} />
        <SensorCharts
          point={pointData}
          regularAiId={pointData?.activeRegularAi?.id}
          isPointLoading={isPointFetching}
        />
      </div>
    </div>
  );
};

export default SensorDetails;
